export default {
  number: 1,
  string: 2,
  date: 3,
  dictionary: 4,
} as const;
